import { injectGlobal } from "styled-components";

injectGlobal`
  :root {
    --font: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    --black: #262626;
    --link-color: #0881b3;
  }
  body {
    width: 100%;
    min-height: 100vh;
    background-color: #F9F9F9;
    box-sizing: border-box;
    font-size: 20px;
    * > {
      box-sizing: inherit;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/global-styles.js